(function () {
  var modalId = 'CustomCreationsQuestionnaire';
  var openClass = 'saintt-questionnaire-is-open';
  var totalQuestions = 14;
  var lastOpenTrigger = null;

  function getModal() {
    return document.getElementById(modalId);
  }

  function getQuestionnaire() {
    var modal = getModal();
    return modal ? modal.querySelector('.saintt-questionnaire') : null;
  }

  function openModal(trigger) {
    var modal = getModal();

    if (!modal) return;

    lastOpenTrigger = trigger || document.activeElement;
    modal.hidden = false;
    document.documentElement.classList.add(openClass);

    window.requestAnimationFrame(function () {
      var closeButton = modal.querySelector('[data-saintt-questionnaire-close]');

      if (closeButton) closeButton.focus({ preventScroll: true });
    });
  }

  function closeModal() {
    var modal = getModal();

    if (!modal) return;

    modal.hidden = true;
    document.documentElement.classList.remove(openClass);

    if (lastOpenTrigger && typeof lastOpenTrigger.focus === 'function') {
      lastOpenTrigger.focus({ preventScroll: true });
    }
  }

  function selectedValues(grid) {
    return Array.prototype.slice
      .call(grid.querySelectorAll('.saintt-questionnaire__option-pill.is-selected'))
      .map(function (button) {
        return button.getAttribute('data-value') || button.textContent.trim();
      })
      .filter(Boolean);
  }

  function updateHiddenAnswer(grid) {
    var form = grid.closest('form');
    var field = form ? form.querySelector('[data-saintt-answer="' + grid.id + '"]') : null;

    if (field) field.value = selectedValues(grid).join(', ');
  }

  function syncOtherReveals(grid) {
    var triggers = grid.querySelectorAll('[data-other-target]');

    Array.prototype.forEach.call(triggers, function (trigger) {
      var targetId = trigger.getAttribute('data-other-target');
      var target = targetId ? document.getElementById(targetId) : null;
      var isVisible = trigger.classList.contains('is-selected');

      if (!target) return;

      target.classList.toggle('is-visible', isVisible);
      target.setAttribute('aria-hidden', isVisible ? 'false' : 'true');

      if (!isVisible) {
        Array.prototype.forEach.call(target.querySelectorAll('input, textarea, select'), function (field) {
          field.value = '';
        });

        Array.prototype.forEach.call(target.querySelectorAll('.saintt-questionnaire__option-pill.is-selected'), function (button) {
          button.classList.remove('is-selected');
          button.setAttribute('aria-pressed', 'false');
        });

        Array.prototype.forEach.call(target.querySelectorAll('.saintt-questionnaire__options-grid[id]'), function (nestedGrid) {
          updateHiddenAnswer(nestedGrid);
        });
      }
    });
  }

  function syncAllAnswers() {
    var questionnaire = getQuestionnaire();

    if (!questionnaire) return;

    Array.prototype.forEach.call(questionnaire.querySelectorAll('.saintt-questionnaire__options-grid[id]'), function (grid) {
      updateHiddenAnswer(grid);
    });
  }

  function questionHasAnswer(block) {
    var selected = block.querySelector('.saintt-questionnaire__option-pill.is-selected');

    if (selected) return true;

    return Array.prototype.some.call(block.querySelectorAll('input, textarea, select'), function (field) {
      if (field.type === 'hidden') return false;
      if (field.closest('.saintt-questionnaire__other-reveal:not(.is-visible)')) return false;
      return field.value.trim() !== '';
    });
  }

  function updateProgress() {
    var questionnaire = getQuestionnaire();

    if (!questionnaire) return;

    var answered = Array.prototype.filter.call(questionnaire.querySelectorAll('.saintt-questionnaire__q-block[data-q]'), questionHasAnswer).length;
    var fill = questionnaire.querySelector('[data-saintt-progress-fill]');
    var label = questionnaire.querySelector('[data-saintt-progress-label]');
    var progress = Math.min(100, Math.round((answered / totalQuestions) * 100));

    if (fill) fill.style.width = progress + '%';
    if (label) label.textContent = answered + ' of ' + totalQuestions;
  }

  function cleanFieldLabel(name) {
    return name.replace(/^contact\[/, '').replace(/\]$/, '');
  }

  function buildSummary(form) {
    var summary = form.querySelector('[data-saintt-summary]');

    if (!summary) return;

    syncAllAnswers();

    var lines = ['Custom Creations Project Brief', ''];

    Array.prototype.forEach.call(form.querySelectorAll('input[name^="contact["], textarea[name^="contact["], select[name^="contact["]'), function (field) {
      var name = field.getAttribute('name');
      var value = field.value.trim();

      if (!value || name === 'contact[body]') return;
      if (field.closest('.saintt-questionnaire__other-reveal:not(.is-visible)')) return;

      lines.push(cleanFieldLabel(name) + ': ' + value);
    });

    summary.value = lines.join('\n');
  }

  function bindInitialState() {
    var questionnaire = getQuestionnaire();

    if (!questionnaire) return;

    Array.prototype.forEach.call(questionnaire.querySelectorAll('.saintt-questionnaire__options-grid[id]'), function (grid) {
      syncOtherReveals(grid);
      updateHiddenAnswer(grid);

      Array.prototype.forEach.call(grid.querySelectorAll('.saintt-questionnaire__option-pill'), function (button) {
        button.setAttribute('aria-pressed', button.classList.contains('is-selected') ? 'true' : 'false');
      });
    });

    updateProgress();

    var state = questionnaire.getAttribute('data-saintt-questionnaire-state');

    if (state === 'success' || state === 'error') {
      openModal();
    }
  }

  document.addEventListener('click', function (event) {
    var openTrigger = event.target.closest('[data-saintt-questionnaire-open]');
    var closeTrigger = event.target.closest('[data-saintt-questionnaire-close]');
    var option = event.target.closest('.saintt-questionnaire__option-pill');

    if (openTrigger) {
      event.preventDefault();
      openModal(openTrigger);
      return;
    }

    if (closeTrigger) {
      event.preventDefault();
      closeModal();
      return;
    }

    if (!option) return;

    var grid = option.closest('.saintt-questionnaire__options-grid');

    if (!grid) return;

    var isMulti = grid.getAttribute('data-multi') === 'true';

    if (isMulti) {
      option.classList.toggle('is-selected');
    } else {
      Array.prototype.forEach.call(grid.querySelectorAll('.saintt-questionnaire__option-pill'), function (button) {
        if (button !== option) {
          button.classList.remove('is-selected');
          button.setAttribute('aria-pressed', 'false');
        }
      });

      option.classList.toggle('is-selected');
    }

    option.setAttribute('aria-pressed', option.classList.contains('is-selected') ? 'true' : 'false');
    syncOtherReveals(grid);
    updateHiddenAnswer(grid);
    updateProgress();
  });

  document.addEventListener('input', function (event) {
    if (!event.target.closest('.saintt-questionnaire')) return;

    updateProgress();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && document.documentElement.classList.contains(openClass)) {
      closeModal();
    }
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('#CustomCreationsProjectBriefForm, .saintt-questionnaire__form');

    if (!form) return;

    buildSummary(form);

    if (typeof form.reportValidity === 'function' && !form.reportValidity()) {
      event.preventDefault();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindInitialState);
  } else {
    bindInitialState();
  }
})();
